import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { baseURL, headers } from "../../../../../global/api";
import { connect } from "react-redux";
import Spinner from "react-bootstrap/Spinner";
import MaterialTable from "material-table";

import { setHeading } from "../../../accounts/account.actions";
import { getReturn } from "./Return.action";
// import { deleteArea, getArea, updateArea } from "./Area.action";

const ViewReturn = (props) => {
  const permissions = JSON.parse(window.localStorage.getItem("permissions"));
  const Checkpermissions = (permissionsType, permissionsName) => {
    return permissions.some((p) => p[`${permissionsType}`] === permissionsName)
      ? false
      : true;
  };
  useEffect(() => {
    props.setHeading("Return List");
    // props.getArea();
  }, []);
  return (
    <>
      {props.isFetchingReturnData ? (
        <div className="loader-div">
          <Spinner
            variant="primary"
            animation="grow"
            size="xl"
            role="status"
            aria-hidden="true"
          />
        </div>
      ) : (
        <Container fluid>
          <div className="main">
            <MaterialTable
              title="Return Details"
              columns={[
                // { title: "Area Name", field: "areaId.areaName" },
                // // { title: "Shop Name", field: "location" },
                // { title: "Sub Total", field: "subTotal" },
                // { title: "Dicount", field: "discount" },
                // { title: "Tax", field: "tax" },
                // { title: "Grand Total", field: "grandTotal" },
              ]}
              data={(query) =>
                new Promise((resolve, reject) => {
                  let url = `${baseURL}/return/?`;
                  url += "limit=" + query.pageSize;
                  url += "&page=" + query.page;
                  url += "&search=" + query.search;
                  fetch(url, {
                    method: "GET",
                    headers: headers,
                  })
                    .then((response) => response.json())
                    .then((result) => {
                      resolve({
                        data: result.data,
                        page: result.page,
                        totalCount: result.total_results,
                      });
                    });
                })
              }
              options={{
                actionsColumnIndex: -1,
                exportButton: true,
                paging: true,
                pageSize: 50, // make initial page size
                emptyRowsWhenPaging: false, // To avoid of having empty rows
                pageSizeOptions: [30, 50, 100, 150, 200], // rows selection options
                headerStyle: {
                  position: "sticky",
                  top: 0,
                  color: "#00BBBB",
                  fontWeight: "550",
                  onRowAdd: "none",
                },
              }}
              editable={{
                // isEditHidden: (rowData) =>
                //   Checkpermissions("permissionsSubCatName", "Area Edit"),
                // isDeleteHidden: (rowData) =>
                //   Checkpermissions("permissionsSubCatName", "Area Delete"),
                onRowUpdate: (newData, oldData) =>
                  new Promise((resolve) => {
                    setTimeout(() => {
                      resolve();
                      {
                        // props.updateArea(newData, oldData);
                      }
                    }, 600);
                  }),
                onRowDelete: (oldData) =>
                  new Promise((resolve) => {
                    setTimeout(() => {
                      resolve();
                      //   props.deleteArea(oldData._id);
                    }, 600);
                  }),
              }}
            />
          </div>
        </Container>
      )}
    </>
  );
};
const mapDispatchToProps = (dispatch) => {
  return {
    getReturn: () => dispatch(getReturn()),
    // updateArea: (newData, oldData) => dispatch(updateArea(newData, oldData)),
    // deleteArea: (id) => dispatch(deleteArea(id)),
    setHeading: (data) => dispatch(setHeading(data)),
  };
};
const mapStateToProps = (state, ownProps) => ({
  // areaDataList: state.AreaReducer.areaDataList,
  // isFetchingAreaData: state.AreaReducer.isFetchingAreaData,
  // shopDataList: state.ShopReducer.shopDataList,
  // isFetchingShopData: state.ShopReducer.isFetchingShopData,
  // orderBookingDataList: state.OrderBookingReducer.orderBookingDataList,
  // isFetchingOrderBookingData:
  //   state.OrderBookingReducer.isFetchingOrderBookingData,
    returnDataList:state.ReturnReducer.returnDataList,
    isFetchingReturnData:state.ReturnReducer.isFetchingReturnData,

});

export default connect(mapStateToProps, mapDispatchToProps)(ViewReturn);
